// @ts-nocheck
import sbjs from 'sourcebuster/dist/sourcebuster.min';

export default defineNuxtPlugin((nuxApp) => {
  nuxApp.hook('app:mounted', () => {
    sbjs.init();
  });
});
